import { render, staticRenderFns } from "./baofei.vue?vue&type=template&id=afb5bd72&scoped=true&"
var script = {}
import style0 from "./baofei.vue?vue&type=style&index=0&id=afb5bd72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb5bd72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afb5bd72')) {
      api.createRecord('afb5bd72', component.options)
    } else {
      api.reload('afb5bd72', component.options)
    }
    module.hot.accept("./baofei.vue?vue&type=template&id=afb5bd72&scoped=true&", function () {
      api.rerender('afb5bd72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/baofei.vue"
export default component.exports